import {theme} from "./Tema";

export const VALORENVIOGRATIS = 350000

export const ESTADOSPRODUCTO = [
    {
        nombre: 'In Stock',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Agotado',
        color: theme.palette.secondary.main
    },
]


export const ESTADOSMAYORISTAS = [
    {
        nombre: 'Nuevo',
        color: '#EA3224'
    },
    {
        nombre: 'Seguimiento',
        color: '#232323'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]


export const ESTADOSPEDIDOS = [
    {
        nombre: 'Nuevo',
        color: '#EA3224'
    },
    {
        nombre: 'Preparando',
        color: '#232323'
    },
    {
        nombre: 'Despachado',
        color: '#5c5c5c'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]

export const LOCALES = [
    {
        nombre: 'Puenes',
        color: '#FFB100'
    },
    {
        nombre: 'Parque 20 de Julio',
        color: '#E30033'
    },
    {
        nombre: 'Carrera 11',
        color: '#5c5c5c'
    }
]


export const ESTADOPEDIDO = [

    {
        nombre: 'Nuevo',
        color: '#796254'
    },
    {
        nombre: 'Seguimiento',
        color: '#796254'
    },
    {
        nombre: 'Preparando',
        color: '#5a6a85'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },
    {
        nombre: 'Empaquetando',
        color: '#808080'
    },
    {
        nombre: 'Enviado',
        color: '#808080'
    },
]


export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Admin',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]

export const ESTADOSPAGO = [
    {
        nombre: 'APPROVED',
        color: '#808080'
    },
    {
        nombre: 'DECLINED',
        color: '#808080'
    },

]


export const ESTADONOTIFICACIONES = [

    {
        nombre: 'Si',
        color: '#796254'
    },
    {
        nombre: 'No',
        color: '#796254'
    }
]

export const ESTADOSMENSAJE = [
    {
        nombre: 'Enviando...',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Enviado',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Abortado',
        color: theme.palette.secondary.main
    },
]